import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchBlogs = createAsyncThunk("blogs/fetchBlogs", async () => {
  const response = await fetch("http://localhost:9000/blogs");
  const data = await response.json();
  return data;
});

const initialState = {
  allPosts: [],
  loading: false,
  error: null,
  sort: "",
  filter: "all",
};

const blogsSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.allPosts = action.payload;
        state.error = null;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.allPosts = [];
        state.error = action.error.message;
      });
  },
});

export const { setSort, setFilter } = blogsSlice.actions;

export default blogsSlice.reducer;
